import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import About from "@/components/About";
import Faq from "@/components/Faq";
import Testimonials from "@/components/Testimonials";
import AreasStrip from "@/components/AreasStrip";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import ProjectDetail from "@/pages/ProjectDetail";
import { initLenis } from "@/lib/scroll";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#121212] text-[#f5f5f0] flex items-center justify-center p-8">
          <p>Something went wrong — please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function MainSite() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="grain bg-[#121212] text-[#f5f5f0] font-sans antialiased selection:bg-[#c5832b] selection:text-[#121212]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <AreasStrip />
        <Services />
        <Projects />
        <Testimonials />
        <About />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/projects/:id" element={<div className="grain bg-[#121212] text-[#f5f5f0] font-sans antialiased min-h-screen"><ProjectDetail /></div>} />
          <Route path="/admin" element={<div className="grain bg-[#121212] text-[#f5f5f0] font-sans antialiased min-h-screen"><Admin /></div>} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
